import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import { Col, Form, Row } from "react-bootstrap"

import { comparateDates, getMondays, sortArray } from "../../utils/utils";

import axios from "../../api/axios";

import Calendar from "react-calendar";
import Select from "../select/Select";
import { Controller } from "react-hook-form";

import { divisiones, emptyOption } from "../../constants/form";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../redux/formDataSlice";

import "../../assets/styles/Forms.css";

const TurnForm = ({ register, control, errors, setValue, check }) => {
  const { escuela } = useSelector(state => state.data);
  const dispatch = useDispatch();

  const [activities, setActivities] = useState([]);
  const [grades, setGrades] = useState([]);

  const [dates, setDates] = useState("");
  const [horaries, setHoraries] = useState("");
  const [horaries_2, setHoraries_2] = useState("");

  const [activity, setActivity] = useState("");
  const [grade, setGrade] = useState("");

  const [date, setDate] = useState("");
  const [turn, setTurn] = useState("");

  const [date_2, setDate_2] = useState("");
  const [turn_2, setTurn_2] = useState("");

  const [gradosDivision, setGradosDivision] = useState([]);

  const [addTurn, setAddTurn] = useState("");

  useEffect(() => {
    if (escuela) {
      const getDates = async () => {
        let response = await axios.post('grades/available', {
          escuela: escuela?.nombre
        });

        let result = response.data?.map(e => {
          return {
            ...e,
            label: e.actividad,
            value: e.actividad,
          }
        });

        setActivities(result);
      };

      getDates();

      setActivity("");
      setGrade("");
      setGrades([]);
      setValue("actividades", "");
      setValue("grade", "");
      setAddTurn("");

      setTurn("");
      setValue("horary", "");
      setDate("");
      setValue("date", "");
      setTurn_2("");
      setValue("horary_2", "");
      setDate_2("");
      setValue("date_2", "");
      setValue("estudiantes", "")
      setValue("estudiantes_2", "")
    }

  }, [escuela, setValue]);

  useEffect(() => {
    if (activity?.actividad) {
      const getDates = async () => {
        let response = await axios.get(`turns/available-dates?actividad=${activity?.actividad}`);
        setDates(response.data);
        setTurn("");
        setTurn_2("");
      };

      getDates();
    }
  }, [activity]);

  useEffect(() => {
    if (activity?.actividad && grade) {
      if (grade?.grado_escuela) {
        const getDates = async () => {
          let response = await axios.post(`units`, { actividad: activity?.actividad, grado: grade?.grado, escuela: escuela.nombre });

          let getDivisiones = response.data?.Restriccione?.DescubriSanNicolas?.map(e => e?.Reservas[0]?.Agentes_Subagente?.Subagente?.division);

          if (getDivisiones) {
            let result = divisiones.filter(e => !getDivisiones?.some(d => e.value === d));

            setGradosDivision(result);
          }
          else {
            setGradosDivision(divisiones);
          }
        };

        getDates();
      }
      else {
        setGradosDivision(divisiones);
      }
    }
  }, [activity, grade, escuela]);


  useEffect(() => {
    if (activity?.actividad && date) {
      const getHorary = async () => {
        dispatch(setLoading(true));
        let response = await axios.get(`/turns/horary?fecha=${date ? date : ""}&&actividad=${activity?.actividad}`);
        if (response.status === 200) {
          if (response.data?.length) {
            let result = sortArray(response.data);

            setHoraries(result.map(e => {
              return {
                ...e,
                value: e.horario,
                label: e.horario
              }
            }));

            dispatch(setLoading(false));
          } else {

            dispatch(setLoading(false));
            setHoraries([]);
          }
        } else {

          dispatch(setLoading(false));
          setHoraries([]);
        }
      }

      getHorary();

    }
    return () => {
      setHoraries([])
    };
  }, [date, activity, dispatch]);


  useEffect(() => {
    if (activity?.actividad && date_2) {
      const getHorary = async () => {
        dispatch(setLoading(true));
        let response = await axios.get(`/turns/horary?fecha=${date_2 ? date_2 : ""}&&actividad=${activity?.actividad}`);
        if (response.status === 200) {

          if (response.data?.length) {
            let sort = sortArray(response.data);

            if (date === date_2) {

              let result = sort.filter(e => e.id !== turn.id);

              setHoraries_2(result.map(e => {
                return {
                  ...e,
                  value: e.horario,
                  label: e.horario
                }
              }));
            } else {
              setHoraries_2(sort.map(e => {
                return {
                  ...e,
                  value: e.horario,
                  label: e.horario
                }
              }));
            }

            dispatch(setLoading(false));
          } else {

            dispatch(setLoading(false));
            setHoraries_2([]);
          }
        } else {

          dispatch(setLoading(false));
          setHoraries_2([]);
        }
      }

      getHorary();

    }
    return () => {
      setHoraries_2([])
    };
  }, [date, date_2, activity, dispatch, horaries, turn]);



  const handleSelect = async (event) => {
    if (event?.value) {
      dispatch(setLoading(true));
      let response = await axios.post('grades/available', {
        escuela: escuela?.nombre
      });

      let grado = response.data.find(a => a.actividad === event.value);

      let grades = grado.Grados.map(e => {
        if (e?.grado_escuela) {
          if (e?.grado_escuela?.length) {
            let grados = e.grado_escuela.filter(b => {
              if (b?.escuela?.nombre === escuela?.nombre) {
                return true;
              }
              else {
                return false;
              }
            });

            if (grados?.length) {
              e.grado_escuela = grados[0];
            }
            else {
              e.grado_escuela = null;
            }

            return e;
          }
          else {
            e.grado_escuela = null;

            return e;
          }
        }
        else {
          return e;
        }
      });

      let result = grades?.map(e => {
        return {
          ...e,
          label: `${e.grado} ${e?.grado_escuela?.disponibles >= 0 ? "- (" + e?.grado_escuela?.disponibles + ")" : ""}`,
          value: e.grado,
          disabled: e?.grado_escuela?.disponibles === 0 ? "true" : "false"
        }
      });


      setGrades(result);
      setGrade("");
      setActivity(event);

      dispatch(setLoading(false));
    } else {
      setGrades([]);
      setGrade("");
      setActivity(event);
    }
  };

  const handleGrade = (e) => {
    setGrade(e);

    if (e?.grado_escuela) {
      setValue("divisiones", "");
      if (+e.grado_escuela?.disponibles > 0) {
        setValue("disponibles", +e.grado_escuela?.disponibles - 1);
      } else {
        setValue("disponibles", +e.grado_escuela?.disponibles);
      }
    } else {
      setValue("disponibles", "");
    }
  };

  const handleHorary = (e) => {
    setValue("id_turn", e.id);
    setTurn(e);
  };

  const handleHorary_2 = (e) => {
    setValue("id_turn_2", e.id);
    setTurn_2(e);
  };

  const handleCheck = (e) => {
    if (e.target.value === "NO") {
      setTurn_2("");
      setDate_2("");

      setValue("horary_2", "")
      setValue("id_turn_2", "")
      setValue("date_2", "")
      setValue("estudiantes_2", "")
    }
    setAddTurn(e.target.value);
    setValue("add_turn", e.target.value);
  };



  return (
    <div className="step-form" >
      <div>
        <h6 className="text-center">
          Turno
        </h6>
      </div>
      <div className="forms">
        <Form.Group>
          <Row className="mb-3">
            <Col sm={12} md={6} lg={6}>
              <Form.Label>Actividades</Form.Label>
              <Select
                name="actividades"
                control={control}
                options={activities?.length ? [emptyOption, ...activities] : [emptyOption]}
                handleChange={handleSelect}
                value={activity ? activity : ""}
                controlled={true}
                className={`${errors.actividades ? "is-invalid" : ""}`}
              />
              <Form.Control.Feedback type="invalid">
                {errors.actividades?.message}
              </Form.Control.Feedback>
            </Col>
            {grades?.length ?
              <Col sm={12} md={6} lg={6}>
                <Form.Label>Curso</Form.Label>
                <Select
                  control={control}
                  options={grades?.length ? [emptyOption, ...grades] : [emptyOption]}
                  handleChange={handleGrade}
                  name="grade"
                  value={grade ? grade : ""}
                  controlled={true}
                  className={`${errors.grade ? "is-invalid" : ""}`}
                  disabled={true}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.grade?.message}
                </Form.Control.Feedback>
              </Col>
              : ""}
          </Row>

          {grade?.value ? (
            <Row className="my-5">
              <Col sm={12} md={4} lg={4}>
                <Form.Label>División del curso</Form.Label>
                <Select
                  control={control}
                  name="division"
                  options={gradosDivision}
                  className={`${errors.division ? "is-invalid" : ""}`}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.division?.message}
                </Form.Control.Feedback>
              </Col>

              <Col sm={12} md={4} lg={4}>
                <Form.Label>Cantidad de estudiantes{addTurn === "SI" ? " 1° turno" : ""}</Form.Label>
                <Form.Control
                  name="estudiantes"
                  type="number"
                  className={`${errors.estudiantes ? "is-invalid" : ""}`}
                  {...register("estudiantes")}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.estudiantes?.message}
                </Form.Control.Feedback>
              </Col>

              {addTurn === "SI" ? (
                <Col sm={12} md={4} lg={4}>
                  <Form.Label>Cantidad de estudiantes 2° turno</Form.Label>
                  <Form.Control
                    name="estudiantes_2"
                    type="number"
                    className={`${errors.estudiantes_2 ? "is-invalid" : ""}`}
                    {...register("estudiantes_2")}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.estudiantes_2?.message}
                  </Form.Control.Feedback>
                </Col>
              ) : ""}
            </Row>
          ) : ""}

          {grade?.value ? (
            <Row>
              <Form.Label className="text-center">¿La cantidad de estudiantes supera el límite de la actividad?</Form.Label>
              <Col className="radio-inputs">
                <div className="d-flex me-2">
                  {/* <Form.Label className="me-2">SI</Form.Label> */}
                  <Form.Check
                    type="radio"
                    name="add_turn"
                    className="radio-input"
                    value={"SI"}
                    onChange={handleCheck}
                    label="SI"
                  />
                </div>
                <div className="d-flex">
                  {/* <Form.Label className="me-2">NO</Form.Label> */}
                  <Form.Check
                    type="radio"
                    name="add_turn"
                    className="radio-input"
                    value={"NO"}
                    defaultChecked
                    onChange={handleCheck}
                    label="NO"
                  />
                </div>
              </Col>
            </Row>
          ) : ""}


          {grade?.value ? (
            <Row className="my-5">
              <h6 className="form-subtitle">1° Turno</h6>
              <Col sm={12} md={6} className="horary">
                <Form.Label>Seleccionar día</Form.Label>
                <Controller
                  control={control}
                  name="date"
                  render={({ field: { onChange, value } }) => {
                    return (
                      <Calendar
                        onChange={(value) => {
                          setTurn("");
                          setValue("horary", "")

                          setDate(format(new Date(value), 'yyyy-MM-dd'));
                          return value ? onChange(format(new Date(value), 'yyyy-MM-dd')) : onChange(value)
                        }}
                        minDate={new Date(getMondays()[0])}
                        maxDate={new Date("2022/11/30")}
                        tileDisabled={({ date }) => date ? comparateDates(date, dates) : false}

                        className={`${errors.date ? "is-invalid" : ""}`}
                        allowPartialRange
                      />
                    )
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.date?.message}
                </Form.Control.Feedback>
              </Col>

              {date ?
                <Col sm={12} md={6} className="ps-3">
                  <Form.Label>Seleccionar horario</Form.Label>
                  <Select
                    control={control}
                    options={horaries?.length ? [emptyOption, ...horaries] : [emptyOption]}
                    handleChange={handleHorary}
                    name="horary"
                    value={turn ? turn : ""}
                    controlled={true}
                    className={`${errors.horary ? "is-invalid" : ""}`}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.horary?.message}
                  </Form.Control.Feedback>
                </Col>
                : ""}
            </Row>
          ) : ""}

          {grade?.value ? (
            <>
              {addTurn === "SI" ? (
                <Row className="my-5">
                  <h6 className="form-subtitle">2° Turno</h6>
                  <Col sm={12} md={6} className="horary">
                    <Form.Label>Seleccionar día</Form.Label>
                    <Controller
                      control={control}
                      name="date_2"
                      render={({ field: { onChange, value } }) => {
                        return (
                          <Calendar
                            onChange={(value) => {
                              setTurn_2("");
                              setValue("horary_2", "")

                              setDate_2(format(new Date(value), 'yyyy-MM-dd'));
                              return value ? onChange(format(new Date(value), 'yyyy-MM-dd')) : onChange(value)
                            }}
                            minDate={new Date(getMondays()[0])}
                            maxDate={new Date("2022/11/30")}
                            tileDisabled={({ date }) => date ? comparateDates(date, dates) : false}
                            className={`${errors.date_2 ? "is-invalid" : ""}`}
                            allowPartialRange
                          />
                        )
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.date_2?.message}
                    </Form.Control.Feedback>
                  </Col>

                  {date_2 ?
                    <Col sm={12} md={6} className="ps-3">
                      <Form.Label>Seleccionar horario</Form.Label>
                      <Select
                        control={control}
                        options={horaries_2?.length ? [emptyOption, ...horaries_2] : [emptyOption]}
                        handleChange={handleHorary_2}
                        name="horary_2"
                        value={turn_2 ? turn_2 : ""}
                        controlled={true}
                        className={`${errors.horary_2 ? "is-invalid" : ""}`}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.horary_2?.message}
                      </Form.Control.Feedback>
                    </Col>
                    : ""}
                </Row>
              ) : ""}
            </>
          )
            : ""}
        </Form.Group>
      </div>
    </div>
  )
};

export default TurnForm;